// ABOUTME: Obfuscation codec that packs a sidepanel descriptor into one opaque URL param.
// ABOUTME: AES-encrypts the descriptor (URL-safe) and decodes it back, returning null on bad input.

import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';

// Shared key mirrors storeEncryptor in src/newapi/transforms/global.js. This obfuscates the
// param from casual view only; it is not security since the key ships in the bundle.
const SECRET = 'simpleobfuscator';

// crypto-js emits standard base64; make it safe to drop into a query string.
const toUrlSafe = (b64) => b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
const fromUrlSafe = (s) => s.replace(/-/g, '+').replace(/_/g, '/');

// descriptor: { k, id, tab?, et?, ei?, wh?, whn? }
export const encodeSidepanel = (descriptor) => {
    const cipher = AES.encrypt(JSON.stringify(descriptor), SECRET).toString();
    return toUrlSafe(cipher);
};

export const decodeSidepanel = (blob) => {
    if (!blob || typeof blob !== 'string') return null;
    try {
        const bytes = AES.decrypt(fromUrlSafe(blob), SECRET);
        const json = bytes.toString(Utf8); // wrong key / tamper -> empty string
        if (!json) return null;
        const obj = JSON.parse(json);
        if (!obj || typeof obj !== 'object' || !obj.k || obj.id === null || obj.id === undefined) {
            return null;
        }
        return obj;
    } catch {
        return null;
    }
};
